/* eslint-disable @typescript-eslint/camelcase */
import { handleActions } from 'redux-actions';
import { DashboardState, PeriodCountAccess } from './interfaces';
import Types from './types';

const initialState: DashboardState = {
  isLoading: false,
  isLoadingGraphs: false,
  companyDashboardData: {
    entity: '',
    name: '',
    uuid: '',
    summary: {
      partners_count: 0,
      environments_count: 0,
      environments_with_instances_count: 0,
      environments_with_instances_percent: 0,
      instances_count: 0,
      clients_count: 0,
      users_count: 0,
      unique_users_count: 0,
      sessions_count: 0,
      created_clients_in_period: {
        count: 0,
        period_in_days: 0,
        growth_in_period_percent: 0,
      },
      created_users_in_period: {
        count: 0,
        period_in_days: 0,
        growth_in_period_percent: 0,
      },
    },
    children: {
      partners: [
        {
          uuid: '',
          summary: {
            environments_count: 0,
            clients_count: 0,
          },
        },
      ],
    },
  },
  companyDashboardPartnerData: {
    entity: '',
    name: '',
    uuid: '',
    summary: {
      clients_count: 0,
      environments_count: 0,
      environments_with_instances_count: 0,
      environments_with_instances_percent: 0,
      instances_count: 0,
      sessions_count: 0,
      unique_users_count: 0,
      users_count: 0,
    },
  },
  partnerDataGraphFields: { metrics: [] },
  periodFilterPartnerGraph: PeriodCountAccess.LAST_30_DAYS,
  periodFilterPartner: PeriodCountAccess.LAST_30_DAYS,
  isLoadingHistory: false,
  partnerEnvironmentsCostGraphFields: { total: '0', metrics: [] },
  partnerEnvironmentsCostPeriodFilter: PeriodCountAccess.LAST_15_DAYS,
  partnerEnvironmentsCostIsLoading: false,
};

export default handleActions(
  {
    [Types.GET_DASHBOARD_DATA_REQUEST]: (state: DashboardState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_DASHBOARD_DATA_FULFILLED]: (
      state: DashboardState,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      companyDashboardData: payload,
    }),
    [Types.GET_DASHBOARD_DATA_REJECTED]: (state: DashboardState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_DASHBOARD_DATA_PARTNER_REQUEST]: (state: DashboardState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_DASHBOARD_DATA_PARTNER_FULFILLED]: (
      state: DashboardState,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      companyDashboardPartnerData: payload,
    }),
    [Types.GET_DASHBOARD_DATA_PARTNER_REJECTED]: (state: DashboardState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.GET_PARTNER_DATA_GRAPH_REQUEST]: (state: DashboardState) => ({
      ...state,
      isLoadingGraphs: true,
    }),
    [Types.GET_PARTNER_DATA_GRAPH_FULFILLED]: (
      state: DashboardState,
      { payload }
    ) => ({
      ...state,
      isLoadingGraphs: false,
      partnerDataGraphFields: payload,
    }),
    [Types.GET_PARTNER_DATA_GRAPH_REJECTED]: (state: DashboardState) => ({
      ...state,
      isLoadingGraphs: false,
    }),
    [Types.SET_PARTNER_DATA_PERIOD_FILTER]: (
      state: DashboardState,
      { payload }
    ) => ({
      ...state,
      periodFilterPartnerGraph: payload,
    }),
    [Types.SET_PARTNER_DATA_PERIOD_CARD_FILTER]: (
      state: DashboardState,
      { payload }
    ) => ({
      ...state,
      periodFilterPartner: payload,
    }),
    [Types.GET_DATA_DASHBOARD_HISTORY_REQUEST]: (state: DashboardState) => ({
      ...state,
      isLoadingHistory: true,
    }),
    [Types.GET_DATA_DASHBOARD_HISTORY_FULFILLED]: (
      state: DashboardState,
      { payload }
    ) => ({
      ...state,
      isLoadingHistory: false,
      companyDashboardData: payload,
    }),
    [Types.GET_DATA_DASHBOARD_HISTORY_REJECTED]: (state: DashboardState) => ({
      ...state,
      isLoadingHistory: false,
    }),
    [Types.GET_PARTNER_ENVIRONMENTS_COST_GRAPH_REQUEST]: (
      state: DashboardState
    ) => ({
      ...state,
      partnerEnvironmentsCostIsLoading: true,
    }),
    [Types.GET_PARTNER_ENVIRONMENTS_COST_GRAPH_FULFILLED]: (
      state: DashboardState,
      { payload }
    ) => ({
      ...state,
      partnerEnvironmentsCostGraphFields: payload,
      partnerEnvironmentsCostIsLoading: false,
    }),
    [Types.GET_PARTNER_ENVIRONMENTS_COST_GRAPH_REJECTED]: (
      state: DashboardState
    ) => ({
      ...state,
      partnerEnvironmentsCostIsLoading: false,
    }),
    [Types.SET_PARTNER_ENVIRONMENTS_COST_PERIOD_FILTER]: (
      state: DashboardState,
      { payload }
    ) => ({
      ...state,
      partnerEnvironmentsCostPeriodFilter: payload,
    }),
  },
  initialState
);
